import React from 'react'
import './Error.css'

const Error = () => {
  return (
    <div>
      <h1>Error</h1>
    </div>
  )
}

export default Error
